export default "__VITE_ASSET__4ef63806__"